"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  category: "RESIDENTIAL LUXURY",
  title: "Interior & Exterior",
  description: "Comprehensive cleaning for both sides of your glass, ensuring a streak-free view from every angle.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_window_cleaning.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_window_cleaning.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_window_cleaning.png-wvc-sizes",
    alt: "Interior and exterior window cleaning"
  }
}, {
  category: "DETAIL ORIENTED",
  title: "Frame & Screen Care",
  description: "We don't just clean glass; we deep clean frames and screens to restore your window's full aesthetic.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/frame_screen_cleaning.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/frame_screen_cleaning.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/frame_screen_cleaning.png-wvc-sizes",
    alt: "Frame and screen cleaning"
  }
}, {
  category: "COMMERCIAL ELITE",
  title: "Low-Rise Commercial",
  description: "Professional cleaning for storefronts and offices up to 3 stories, maintaining your business's premium image.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/commercial_window_cleaning.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/commercial_window_cleaning.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/commercial_window_cleaning.png-wvc-sizes",
    alt: "Commercial window cleaning"
  }
}, {
  category: "RESTORATION",
  title: "Hard Water Removal",
  description: "Specialized treatment to eliminate stubborn mineral deposits and restore the clarity of your glass.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/hard_water_stain_removal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/hard_water_stain_removal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/hard_water_stain_removal.png-wvc-sizes",
    alt: "Hard water stain removal"
  }
}, {
  category: "MAINTENANCE",
  title: "Seasonal Cleaning",
  description: "Scheduled maintenance to protect your windows from the elements and keep them sparkling year-round.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/seasonal_window_maintenance.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/seasonal_window_maintenance.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/seasonal_window_maintenance.png-wvc-sizes",
    alt: "Seasonal window maintenance"
  }
}, {
  category: "PRECISION",
  title: "Luxury Home Service",
  description: "White-glove service tailored for high-end estates in the GTA, Toronto, and north of Newmarket.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_estate_cleaning.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_estate_cleaning.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_estate_cleaning.png-wvc-sizes",
    alt: "Luxury home window cleaning"
  }
}];
export default function OurPremiumServices() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258908" id="our-premium-services" className="bg-background text-foreground section-spacing">
      <div className="container-global">
        {}
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-sm font-bold tracking-widest uppercase text-primary mb-3 block font-default">
            Our Expertise
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold text-foreground font-default mb-6 tracking-tighter"><span className="text-primary">Luxury Level Window Cleaning</span></h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default font-light leading-relaxed">
            From residential estates to low-rise commercial properties, we deliver a pristine finish starting at just $90.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => {
          const cardReveal = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={index} data-index={index} ref={cardReveal.ref} className={`group relative overflow-hidden rounded-md aspect-[4/3] md:aspect-[4/3] lg:aspect-[5/4] cursor-pointer transition-all duration-700 delay-[${index * 100}ms] border-t border-white/10 shadow-lg ${cardReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                {}
                <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent transition-all duration-500 group-hover:backdrop-blur-sm" />

                {}
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end z-10">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs font-bold uppercase tracking-widest text-white/70 font-default">
                      {service.category}
                    </span>
                    <span className="text-xs font-bold bg-white text-black px-2 py-1 rounded-sm font-default">
                      FROM $90
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3 font-default tracking-tight">
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-base text-white/80 line-clamp-2 md:line-clamp-3 font-default font-light">
                    {service.description}
                  </p>
                  <div className="mt-4 flex items-center text-white text-sm font-bold opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 font-default">
                    LEARN MORE <span className="ml-2 transition-transform duration-300 group-hover:translate-x-2">→</span>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}